/**
 * What TACH approves a carrier on, said the same way everywhere.
 *
 * This claim already existed in five places in five phrasings before it lived here — the Plaid
 * step, the onboarding widget, the welcome step, the landing page and the FAQ each had their own
 * variant. It is a claim about underwriting, so the variants have to agree: `UnderwritingDecisionData`
 * records revenue, authority, safety rating, inspections, insurance and mileage, and carries no
 * credit-score field at all. Nothing here is marketing licence — every clause is a thing the
 * underwriting workflow actually checks, or a thing it demonstrably never does.
 *
 * Stated on the revenue-verification step, which is where the customer is being asked for bank
 * access and the question is live. Deliberately NOT in TrustSignals: that panel is the
 * application's compliance furniture — FDIC, Pathward, security, legal links — and this claim
 * sitting in it reads as marketing wherever it is placed, however quietly it is styled.
 */
export const APPROVAL_BASIS = {
  /** The two negatives. Always bolded, always first. */
  lead: 'No personal credit check. No personal guarantee.',

  /**
   * The revenue-verification step, where the question is sharpest: the customer has just been
   * asked for bank access. Says "cash flow" rather than "revenue" because that screen is already
   * headed "Verify Your Business Revenue" and the echo reads as circular.
   */
  revenueStepBody:
    'To open your TACH account, we approve your company on its verified cash flow and operating record — not your FICO score.',
} as const;
